import { ContractFunctionArgs, ContractFunctionName, erc20Abi } from 'viem'
import { useReadContract } from 'wagmi'

import { env } from '@/config/env'
const { tokenAddress } = env

export const useTokenReadContract = (
  functionName: ContractFunctionName<typeof erc20Abi, 'pure' | 'view'>,
  args: ContractFunctionArgs<typeof erc20Abi, 'pure' | 'view', typeof functionName>,
) => {
  return useReadContract({
    address: tokenAddress,
    abi: erc20Abi,
    functionName,
    args,
  })
}
